import rivets from 'rivets';
import BaseView from '../../core/baseView';
import * as lightbox from '../../../home24/helpers/lightbox';

export default BaseView.extend({
  events: {
    'change [name="payment[installment_purchase_number_of_months]"]':
      'updateModel',
    'click #installmentDetails': 'onDetailsClick',
    'click .more-label': 'onMoreLabelClick'
  },

  initialize: function() {
    /*
         Bind rivets
         */
    this.binding = rivets.bind(this.el, {
      installment: this.model
    });

    this.updateModel();
  },

  updateModel: function() {
    this.model.load(
      this.$('[name="payment[installment_purchase_number_of_months]"]').val()
    );
  },

  onDetailsClick: function() {
    lightbox
      .setConfig({
        $dialog: this.$('#finance-details'),
        className: 'finance-details'
      })
      .open();
  },

  onMoreLabelClick: function() {
    this.$('.more-content').removeClass('is-hidden');
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/checkout/paymentInstallmentView.js
 **/